import { useContext, useEffect } from 'react';

import { IsGoogleMapsLoadingContext, RunGoogleMapsEffectContext } from '../context';

export const useIsGoogleMapsLoading = () => useContext(IsGoogleMapsLoadingContext)!;
export const useRunGoogleMapsEffect = () => useContext(RunGoogleMapsEffectContext)!;

export const useGoogleMaps = () => {
	const isLoading = useIsGoogleMapsLoading();
	const runMapsEffect = useRunGoogleMapsEffect();

	useEffect(() => {
		runMapsEffect();
	}, []);

	return isLoading;
}